import { cssBreakpoints } from '../../common/breakpoints';
import appDesktop from './appDesktop';
import appMobile from './appMobile';

const app = (window) => {
  let currentApp = null;
  let currentAppInstance = null;

  const cssBreakpointMatchMedia = matchMedia(`(min-width: ${cssBreakpoints.md})`);

  const switchApp = e => {
    const nextApp = e.matches
      ? appDesktop
      : appMobile;

    if (nextApp !== currentApp) {
      if (currentAppInstance !== null) {
        currentAppInstance.destroy();
      }
    }

    currentApp = nextApp;
    currentAppInstance = currentApp(window);
  };

  cssBreakpointMatchMedia.addEventListener('change', (e) => switchApp(e));
  switchApp(cssBreakpointMatchMedia);
};

export default app;
